/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { Elements } from './elements';

export abstract class WidgetElements extends Elements {
  public abstract getFormHead(): HTMLElement;
  public abstract getFormSubtitle(): HTMLElement;
  public abstract getUsernameLabel(): HTMLElement;
  public abstract getPasswordLabel(): HTMLElement;
  public abstract getPasswordField(): HTMLInputElement;
  public abstract getPasswordAutofilledField(): HTMLInputElement;
  public abstract getOldPasswordField(): HTMLInputElement;
  public abstract getNewPasswordField(): HTMLInputElement;
  public abstract getConfirmPasswordField(): HTMLInputElement;
  public abstract getUsernameFieldset(): HTMLElement;
  public abstract getAccountRecoveryUsernameLabel(): HTMLElement;
  public abstract getAccountRecoveryUsernameField(): HTMLInputElement;
  public abstract getEmailButton(): HTMLButtonElement;
  public abstract getAuthFooter(): HTMLElement;
  public abstract getContextParent(): HTMLElement;
  public abstract getContextFromWidget(): string;
  public abstract getErrorContainer(): HTMLElement;
  public abstract getPhoneField(): HTMLInputElement;
  public abstract getPasscodeField(): HTMLInputElement;
  public abstract getAnswerField(): HTMLInputElement;
  public abstract getSmsRequestButtons(): HTMLButtonElement[];
  public abstract getCallRequestButtons(): HTMLButtonElement[];
  public abstract getHeaderBeacon(): HTMLElement;
  public abstract getMultiMfaDropdownFieldset(): HTMLElement;
  public abstract getMultiMfaDropdown(): HTMLElement;
  public abstract getMfaEnrollmentFactorTile(factor: string): HTMLElement;
  public abstract getMfaFactor(): string;
  public abstract getUsernameField(): HTMLInputElement;
  public abstract getCountryDropdownField(): HTMLElement;
}
